/**
 * Returns the full MRT API base path concatenated with the provided path.
 *
 * @param {string} [path=''] - The path to be appended to the MRT API base path.
 * @returns {string} The full MRT API base path with the appended path.
 */
import {MRT_API_BASEPATH} from '../constants'

export function getMrtApiBasepath(path = '') {
    return MRT_API_BASEPATH + path
}
